export class TypeInfosRectif {

	public auLieuDe: string;

	public lire: string;

	public ajouter: string;

	public apresLaMention: string;

	public supprimer: string;

	public rubrique: string;

	public lireDate: string;

	public rubDelais: string;

	public auLieuDeDate: string;

	public isALS: string;

	constructor() { 
		 		this.auLieuDe = '';
		this.lire = '';
		this.ajouter = '';
		this.apresLaMention = '';
		this.supprimer = '';
		this.rubrique = '';
		this.lireDate = null;
		this.rubDelais = '';
		this.auLieuDeDate = null;
		this.isALS = '';
	}
}
